import { render } from "./LegacyFilter.vue?vue&type=template&id=070344de"
import script from "./LegacyFilter.vue?vue&type=script&lang=js"
export * from "./LegacyFilter.vue?vue&type=script&lang=js"
script.render = render

export default script